module.exports = "fonts/LYjNdG7kmE0gfa19pRtB.woff2";